import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom'
import { AppShell, type ScreenKey } from './components/AppShell'
import { UpdatePrompt } from './components/UpdatePrompt'
import { AuthCallbackScreen } from './screens/AuthCallbackScreen'
import { TimelineScreen } from './screens/HistoryScreen'
import { InviteScreen } from './screens/InviteScreen'
import { ScoreboardScreen } from './screens/ScoreboardScreen'
import { SettingsScreen } from './screens/SettingsScreen'
import { TodayScreen } from './screens/TodayScreen'
import { WallScreen } from './screens/WallScreen'
import { OwnerMatrixProvider } from './owner/OwnerMatrixContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { OwnerAccessGate } from './components/OwnerAccessGate'

const validScreens = new Set<ScreenKey>(['today', 'timeline', 'scoreboard', 'settings'])

function OwnerApp() {
  const [params] = useSearchParams()
  const requested = params.get('screen') ?? 'today'
  const compatibleRequested = requested === 'history' ? 'timeline' : requested
  const screen: ScreenKey = validScreens.has(compatibleRequested as ScreenKey) ? compatibleRequested as ScreenKey : 'today'
  return <ErrorBoundary><OwnerAccessGate><OwnerMatrixProvider><AppShell screen={screen}>{screen === 'today' ? <TodayScreen /> : screen === 'timeline' ? <TimelineScreen /> : screen === 'scoreboard' ? <ScoreboardScreen /> : <SettingsScreen />}</AppShell></OwnerMatrixProvider></OwnerAccessGate></ErrorBoundary>
}

export function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<OwnerApp />} />
        <Route path="/wall" element={<WallScreen />} />
        <Route path="/invite" element={<InviteScreen />} />
        <Route path="/auth/callback" element={<AuthCallbackScreen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <UpdatePrompt />
    </>
  )
}
